/**
 * Generated by orval 🍺
 * Do not edit manually.
 * MyRentalMate API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  BodyAddPortalRequestPhoto,
  DownloadUrlOut,
  HTTPValidationError,
  InspectionAcknowledgeIn,
  LeaseLedgerOut,
  ListPortalPaymentsParams,
  PaginatedPaymentOut,
  PortalAttemptsOut,
  PortalContactIn,
  PortalDepositLettersOut,
  PortalDocumentsOut,
  PortalHomeOut,
  PortalInspectionsOut,
  PortalNoticesOut,
  PortalPaymentIn,
  PortalPaymentStartOut,
  PortalPreferencesIn,
  PortalRenewalsOut,
  PortalRequestIn,
  PortalRequestOut,
  PortalRequestsOut,
  RenewalResponseIn
} from '../model';

import { apiFetch } from '../../fetcher';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type getPortalHomeResponse200 = {
  data: PortalHomeOut
  status: 200
}

export type getPortalHomeResponseSuccess = (getPortalHomeResponse200) & {
  headers: Headers;
};
;

export type getPortalHomeResponse = (getPortalHomeResponseSuccess)

export const getGetPortalHomeUrl = () => {




  return `/api/portal/home`
}

/**
 * @summary Get Portal Home
 */
export const getPortalHome = async ( options?: Parameters<typeof apiFetch>[1]): Promise<getPortalHomeResponse> => {

  return apiFetch<getPortalHomeResponse>(getGetPortalHomeUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPortalHomeQueryKey = () => {
    return [
    `/api/portal/home`
    ] as const;
    }


export const getGetPortalHomeQueryOptions = <TData = Awaited<ReturnType<typeof getPortalHome>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPortalHome>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPortalHomeQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPortalHome>>> = ({ signal }) => getPortalHome({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPortalHome>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPortalHomeQueryResult = NonNullable<Awaited<ReturnType<typeof getPortalHome>>>
export type GetPortalHomeQueryError = unknown


export function useGetPortalHome<TData = Awaited<ReturnType<typeof getPortalHome>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPortalHome>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPortalHome>>,
          TError,
          Awaited<ReturnType<typeof getPortalHome>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPortalHome<TData = Awaited<ReturnType<typeof getPortalHome>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPortalHome>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPortalHome>>,
          TError,
          Awaited<ReturnType<typeof getPortalHome>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPortalHome<TData = Awaited<ReturnType<typeof getPortalHome>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPortalHome>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Portal Home
 */

export function useGetPortalHome<TData = Awaited<ReturnType<typeof getPortalHome>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPortalHome>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPortalHomeQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type updatePortalContactResponse200 = {
  data: PortalHomeOut
  status: 200
}

export type updatePortalContactResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type updatePortalContactResponseSuccess = (updatePortalContactResponse200) & {
  headers: Headers;
};
export type updatePortalContactResponseError = (updatePortalContactResponse422) & {
  headers: Headers;
};

export type updatePortalContactResponse = (updatePortalContactResponseSuccess | updatePortalContactResponseError)

export const getUpdatePortalContactUrl = () => {




  return `/api/portal/contact`
}

/**
 * @summary Update Portal Contact
 */
export const updatePortalContact = async (portalContactIn: PortalContactIn, options?: Parameters<typeof apiFetch>[1]): Promise<updatePortalContactResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<updatePortalContactResponse>(getUpdatePortalContactUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(portalContactIn)
  }
);}





export const getUpdatePortalContactMutationKey = () => ['updatePortalContact'] as const;

export const getUpdatePortalContactMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePortalContact>>, TError,UpdatePortalContactMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updatePortalContact>>, TError,UpdatePortalContactMutationVariables, TContext> => {

const mutationKey = getUpdatePortalContactMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePortalContact>>, UpdatePortalContactMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  updatePortalContact(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePortalContactMutationResult = NonNullable<Awaited<ReturnType<typeof updatePortalContact>>>
    export type UpdatePortalContactMutationBody = PortalContactIn
    export type UpdatePortalContactMutationError = HTTPValidationError
    export type UpdatePortalContactMutationVariables = {data: PortalContactIn}

    /**
 * @summary Update Portal Contact
 */
export const useUpdatePortalContact = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePortalContact>>, TError,UpdatePortalContactMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updatePortalContact>>,
        TError,
        UpdatePortalContactMutationVariables,
        TContext
      > => {
      return useMutation(getUpdatePortalContactMutationOptions(options), queryClient);
    }
    export type updatePortalPreferencesResponse200 = {
  data: PortalHomeOut
  status: 200
}

export type updatePortalPreferencesResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type updatePortalPreferencesResponseSuccess = (updatePortalPreferencesResponse200) & {
  headers: Headers;
};
export type updatePortalPreferencesResponseError = (updatePortalPreferencesResponse422) & {
  headers: Headers;
};

export type updatePortalPreferencesResponse = (updatePortalPreferencesResponseSuccess | updatePortalPreferencesResponseError)

export const getUpdatePortalPreferencesUrl = () => {




  return `/api/portal/preferences`
}

/**
 * @summary Update Portal Preferences
 */
export const updatePortalPreferences = async (portalPreferencesIn: PortalPreferencesIn, options?: Parameters<typeof apiFetch>[1]): Promise<updatePortalPreferencesResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<updatePortalPreferencesResponse>(getUpdatePortalPreferencesUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(portalPreferencesIn)
  }
);}





export const getUpdatePortalPreferencesMutationKey = () => ['updatePortalPreferences'] as const;

export const getUpdatePortalPreferencesMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePortalPreferences>>, TError,UpdatePortalPreferencesMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updatePortalPreferences>>, TError,UpdatePortalPreferencesMutationVariables, TContext> => {

const mutationKey = getUpdatePortalPreferencesMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePortalPreferences>>, UpdatePortalPreferencesMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  updatePortalPreferences(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePortalPreferencesMutationResult = NonNullable<Awaited<ReturnType<typeof updatePortalPreferences>>>
    export type UpdatePortalPreferencesMutationBody = PortalPreferencesIn
    export type UpdatePortalPreferencesMutationError = HTTPValidationError
    export type UpdatePortalPreferencesMutationVariables = {data: PortalPreferencesIn}

    /**
 * @summary Update Portal Preferences
 */
export const useUpdatePortalPreferences = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePortalPreferences>>, TError,UpdatePortalPreferencesMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updatePortalPreferences>>,
        TError,
        UpdatePortalPreferencesMutationVariables,
        TContext
      > => {
      return useMutation(getUpdatePortalPreferencesMutationOptions(options), queryClient);
    }
    export type getPortalLedgerResponse200 = {
  data: LeaseLedgerOut
  status: 200
}

export type getPortalLedgerResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type getPortalLedgerResponseSuccess = (getPortalLedgerResponse200) & {
  headers: Headers;
};
export type getPortalLedgerResponseError = (getPortalLedgerResponse422) & {
  headers: Headers;
};

export type getPortalLedgerResponse = (getPortalLedgerResponseSuccess | getPortalLedgerResponseError)

export const getGetPortalLedgerUrl = (leaseId: number,) => {




  return `/api/portal/leases/${leaseId}/ledger`
}

/**
 * @summary Get Portal Ledger
 */
export const getPortalLedger = async (leaseId: number, options?: Parameters<typeof apiFetch>[1]): Promise<getPortalLedgerResponse> => {

  return apiFetch<getPortalLedgerResponse>(getGetPortalLedgerUrl(leaseId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPortalLedgerQueryKey = (leaseId: number,) => {
    return [
    `/api/portal/leases/${leaseId}/ledger`
    ] as const;
    }


export const getGetPortalLedgerQueryOptions = <TData = Awaited<ReturnType<typeof getPortalLedger>>, TError = HTTPValidationError>(leaseId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPortalLedger>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPortalLedgerQueryKey(leaseId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPortalLedger>>> = ({ signal }) => getPortalLedger(leaseId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: leaseId !== null && leaseId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPortalLedger>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPortalLedgerQueryResult = NonNullable<Awaited<ReturnType<typeof getPortalLedger>>>
export type GetPortalLedgerQueryError = HTTPValidationError


export function useGetPortalLedger<TData = Awaited<ReturnType<typeof getPortalLedger>>, TError = HTTPValidationError>(
 leaseId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPortalLedger>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPortalLedger>>,
          TError,
          Awaited<ReturnType<typeof getPortalLedger>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPortalLedger<TData = Awaited<ReturnType<typeof getPortalLedger>>, TError = HTTPValidationError>(
 leaseId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPortalLedger>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPortalLedger>>,
          TError,
          Awaited<ReturnType<typeof getPortalLedger>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPortalLedger<TData = Awaited<ReturnType<typeof getPortalLedger>>, TError = HTTPValidationError>(
 leaseId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPortalLedger>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Portal Ledger
 */

export function useGetPortalLedger<TData = Awaited<ReturnType<typeof getPortalLedger>>, TError = HTTPValidationError>(
 leaseId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPortalLedger>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPortalLedgerQueryOptions(leaseId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type listPortalPaymentsResponse200 = {
  data: PaginatedPaymentOut
  status: 200
}

export type listPortalPaymentsResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type listPortalPaymentsResponseSuccess = (listPortalPaymentsResponse200) & {
  headers: Headers;
};
export type listPortalPaymentsResponseError = (listPortalPaymentsResponse422) & {
  headers: Headers;
};

export type listPortalPaymentsResponse = (listPortalPaymentsResponseSuccess | listPortalPaymentsResponseError)

export const getListPortalPaymentsUrl = (params?: ListPortalPaymentsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/portal/payments?${stringifiedParams}` : `/api/portal/payments`
}

/**
 * @summary List Portal Payments
 */
export const listPortalPayments = async (params?: ListPortalPaymentsParams, options?: Parameters<typeof apiFetch>[1]): Promise<listPortalPaymentsResponse> => {

  return apiFetch<listPortalPaymentsResponse>(getListPortalPaymentsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPortalPaymentsQueryKey = (params?: ListPortalPaymentsParams,) => {
    return [
    `/api/portal/payments`, ...(params ? [params] : [])
    ] as const;
    }


export const getListPortalPaymentsQueryOptions = <TData = Awaited<ReturnType<typeof listPortalPayments>>, TError = HTTPValidationError>(params?: ListPortalPaymentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPortalPayments>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPortalPaymentsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPortalPayments>>> = ({ signal }) => listPortalPayments(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPortalPayments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListPortalPaymentsQueryResult = NonNullable<Awaited<ReturnType<typeof listPortalPayments>>>
export type ListPortalPaymentsQueryError = HTTPValidationError


export function useListPortalPayments<TData = Awaited<ReturnType<typeof listPortalPayments>>, TError = HTTPValidationError>(
 params: undefined |  ListPortalPaymentsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPortalPayments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPortalPayments>>,
          TError,
          Awaited<ReturnType<typeof listPortalPayments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPortalPayments<TData = Awaited<ReturnType<typeof listPortalPayments>>, TError = HTTPValidationError>(
 params?: ListPortalPaymentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPortalPayments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPortalPayments>>,
          TError,
          Awaited<ReturnType<typeof listPortalPayments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPortalPayments<TData = Awaited<ReturnType<typeof listPortalPayments>>, TError = HTTPValidationError>(
 params?: ListPortalPaymentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPortalPayments>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Portal Payments
 */

export function useListPortalPayments<TData = Awaited<ReturnType<typeof listPortalPayments>>, TError = HTTPValidationError>(
 params?: ListPortalPaymentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPortalPayments>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPortalPaymentsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type startPortalPaymentResponse200 = {
  data: PortalPaymentStartOut
  status: 200
}

export type startPortalPaymentResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type startPortalPaymentResponseSuccess = (startPortalPaymentResponse200) & {
  headers: Headers;
};
export type startPortalPaymentResponseError = (startPortalPaymentResponse422) & {
  headers: Headers;
};

export type startPortalPaymentResponse = (startPortalPaymentResponseSuccess | startPortalPaymentResponseError)

export const getStartPortalPaymentUrl = () => {




  return `/api/portal/payments`
}

/**
 * @summary Start Portal Payment
 */
export const startPortalPayment = async (portalPaymentIn: PortalPaymentIn, options?: Parameters<typeof apiFetch>[1]): Promise<startPortalPaymentResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<startPortalPaymentResponse>(getStartPortalPaymentUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(portalPaymentIn)
  }
);}





export const getStartPortalPaymentMutationKey = () => ['startPortalPayment'] as const;

export const getStartPortalPaymentMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startPortalPayment>>, TError,StartPortalPaymentMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof startPortalPayment>>, TError,StartPortalPaymentMutationVariables, TContext> => {

const mutationKey = getStartPortalPaymentMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startPortalPayment>>, StartPortalPaymentMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  startPortalPayment(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StartPortalPaymentMutationResult = NonNullable<Awaited<ReturnType<typeof startPortalPayment>>>
    export type StartPortalPaymentMutationBody = PortalPaymentIn
    export type StartPortalPaymentMutationError = HTTPValidationError
    export type StartPortalPaymentMutationVariables = {data: PortalPaymentIn}

    /**
 * @summary Start Portal Payment
 */
export const useStartPortalPayment = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startPortalPayment>>, TError,StartPortalPaymentMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof startPortalPayment>>,
        TError,
        StartPortalPaymentMutationVariables,
        TContext
      > => {
      return useMutation(getStartPortalPaymentMutationOptions(options), queryClient);
    }
    export type listPortalPaymentAttemptsResponse200 = {
  data: PortalAttemptsOut
  status: 200
}

export type listPortalPaymentAttemptsResponseSuccess = (listPortalPaymentAttemptsResponse200) & {
  headers: Headers;
};
;

export type listPortalPaymentAttemptsResponse = (listPortalPaymentAttemptsResponseSuccess)

export const getListPortalPaymentAttemptsUrl = () => {




  return `/api/portal/payments/attempts`
}

/**
 * @summary List Portal Payment Attempts
 */
export const listPortalPaymentAttempts = async ( options?: Parameters<typeof apiFetch>[1]): Promise<listPortalPaymentAttemptsResponse> => {

  return apiFetch<listPortalPaymentAttemptsResponse>(getListPortalPaymentAttemptsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPortalPaymentAttemptsQueryKey = () => {
    return [
    `/api/portal/payments/attempts`
    ] as const;
    }


export const getListPortalPaymentAttemptsQueryOptions = <TData = Awaited<ReturnType<typeof listPortalPaymentAttempts>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPortalPaymentAttempts>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPortalPaymentAttemptsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPortalPaymentAttempts>>> = ({ signal }) => listPortalPaymentAttempts({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPortalPaymentAttempts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListPortalPaymentAttemptsQueryResult = NonNullable<Awaited<ReturnType<typeof listPortalPaymentAttempts>>>
export type ListPortalPaymentAttemptsQueryError = unknown


export function useListPortalPaymentAttempts<TData = Awaited<ReturnType<typeof listPortalPaymentAttempts>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPortalPaymentAttempts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPortalPaymentAttempts>>,
          TError,
          Awaited<ReturnType<typeof listPortalPaymentAttempts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPortalPaymentAttempts<TData = Awaited<ReturnType<typeof listPortalPaymentAttempts>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPortalPaymentAttempts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPortalPaymentAttempts>>,
          TError,
          Awaited<ReturnType<typeof listPortalPaymentAttempts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPortalPaymentAttempts<TData = Awaited<ReturnType<typeof listPortalPaymentAttempts>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPortalPaymentAttempts>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Portal Payment Attempts
 */

export function useListPortalPaymentAttempts<TData = Awaited<ReturnType<typeof listPortalPaymentAttempts>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPortalPaymentAttempts>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPortalPaymentAttemptsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type getPortalReceiptResponse200 = {
  data: Blob
  status: 200
}

export type getPortalReceiptResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type getPortalReceiptResponseSuccess = (getPortalReceiptResponse200) & {
  headers: Headers;
};
export type getPortalReceiptResponseError = (getPortalReceiptResponse422) & {
  headers: Headers;
};

export type getPortalReceiptResponse = (getPortalReceiptResponseSuccess | getPortalReceiptResponseError)

export const getGetPortalReceiptUrl = (paymentId: number,) => {




  return `/api/portal/payments/${paymentId}/receipt`
}

/**
 * @summary Get Portal Receipt
 */
export const getPortalReceipt = async (paymentId: number, options?: Parameters<typeof apiFetch>[1]): Promise<getPortalReceiptResponse> => {

  return apiFetch<getPortalReceiptResponse>(getGetPortalReceiptUrl(paymentId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPortalReceiptQueryKey = (paymentId: number,) => {
    return [
    `/api/portal/payments/${paymentId}/receipt`
    ] as const;
    }


export const getGetPortalReceiptQueryOptions = <TData = Awaited<ReturnType<typeof getPortalReceipt>>, TError = HTTPValidationError>(paymentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPortalReceipt>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPortalReceiptQueryKey(paymentId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPortalReceipt>>> = ({ signal }) => getPortalReceipt(paymentId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: paymentId !== null && paymentId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPortalReceipt>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPortalReceiptQueryResult = NonNullable<Awaited<ReturnType<typeof getPortalReceipt>>>
export type GetPortalReceiptQueryError = HTTPValidationError


export function useGetPortalReceipt<TData = Awaited<ReturnType<typeof getPortalReceipt>>, TError = HTTPValidationError>(
 paymentId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPortalReceipt>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPortalReceipt>>,
          TError,
          Awaited<ReturnType<typeof getPortalReceipt>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPortalReceipt<TData = Awaited<ReturnType<typeof getPortalReceipt>>, TError = HTTPValidationError>(
 paymentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPortalReceipt>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPortalReceipt>>,
          TError,
          Awaited<ReturnType<typeof getPortalReceipt>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPortalReceipt<TData = Awaited<ReturnType<typeof getPortalReceipt>>, TError = HTTPValidationError>(
 paymentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPortalReceipt>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Portal Receipt
 */

export function useGetPortalReceipt<TData = Awaited<ReturnType<typeof getPortalReceipt>>, TError = HTTPValidationError>(
 paymentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPortalReceipt>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPortalReceiptQueryOptions(paymentId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type listPortalRequestsResponse200 = {
  data: PortalRequestsOut
  status: 200
}

export type listPortalRequestsResponseSuccess = (listPortalRequestsResponse200) & {
  headers: Headers;
};
;

export type listPortalRequestsResponse = (listPortalRequestsResponseSuccess)

export const getListPortalRequestsUrl = () => {




  return `/api/portal/maintenance`
}

/**
 * @summary List Portal Requests
 */
export const listPortalRequests = async ( options?: Parameters<typeof apiFetch>[1]): Promise<listPortalRequestsResponse> => {

  return apiFetch<listPortalRequestsResponse>(getListPortalRequestsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPortalRequestsQueryKey = () => {
    return [
    `/api/portal/maintenance`
    ] as const;
    }


export const getListPortalRequestsQueryOptions = <TData = Awaited<ReturnType<typeof listPortalRequests>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPortalRequests>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPortalRequestsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPortalRequests>>> = ({ signal }) => listPortalRequests({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPortalRequests>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListPortalRequestsQueryResult = NonNullable<Awaited<ReturnType<typeof listPortalRequests>>>
export type ListPortalRequestsQueryError = unknown


export function useListPortalRequests<TData = Awaited<ReturnType<typeof listPortalRequests>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPortalRequests>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPortalRequests>>,
          TError,
          Awaited<ReturnType<typeof listPortalRequests>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPortalRequests<TData = Awaited<ReturnType<typeof listPortalRequests>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPortalRequests>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPortalRequests>>,
          TError,
          Awaited<ReturnType<typeof listPortalRequests>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPortalRequests<TData = Awaited<ReturnType<typeof listPortalRequests>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPortalRequests>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Portal Requests
 */

export function useListPortalRequests<TData = Awaited<ReturnType<typeof listPortalRequests>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPortalRequests>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPortalRequestsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type createPortalRequestResponse201 = {
  data: PortalRequestOut
  status: 201
}

export type createPortalRequestResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type createPortalRequestResponseSuccess = (createPortalRequestResponse201) & {
  headers: Headers;
};
export type createPortalRequestResponseError = (createPortalRequestResponse422) & {
  headers: Headers;
};

export type createPortalRequestResponse = (createPortalRequestResponseSuccess | createPortalRequestResponseError)

export const getCreatePortalRequestUrl = () => {




  return `/api/portal/maintenance`
}

/**
 * @summary Create Portal Request
 */
export const createPortalRequest = async (portalRequestIn: PortalRequestIn, options?: Parameters<typeof apiFetch>[1]): Promise<createPortalRequestResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<createPortalRequestResponse>(getCreatePortalRequestUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(portalRequestIn)
  }
);}





export const getCreatePortalRequestMutationKey = () => ['createPortalRequest'] as const;

export const getCreatePortalRequestMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPortalRequest>>, TError,CreatePortalRequestMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createPortalRequest>>, TError,CreatePortalRequestMutationVariables, TContext> => {

const mutationKey = getCreatePortalRequestMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPortalRequest>>, CreatePortalRequestMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createPortalRequest(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePortalRequestMutationResult = NonNullable<Awaited<ReturnType<typeof createPortalRequest>>>
    export type CreatePortalRequestMutationBody = PortalRequestIn
    export type CreatePortalRequestMutationError = HTTPValidationError
    export type CreatePortalRequestMutationVariables = {data: PortalRequestIn}

    /**
 * @summary Create Portal Request
 */
export const useCreatePortalRequest = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPortalRequest>>, TError,CreatePortalRequestMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createPortalRequest>>,
        TError,
        CreatePortalRequestMutationVariables,
        TContext
      > => {
      return useMutation(getCreatePortalRequestMutationOptions(options), queryClient);
    }
    export type addPortalRequestPhotoResponse200 = {
  data: PortalRequestOut
  status: 200
}

export type addPortalRequestPhotoResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type addPortalRequestPhotoResponseSuccess = (addPortalRequestPhotoResponse200) & {
  headers: Headers;
};
export type addPortalRequestPhotoResponseError = (addPortalRequestPhotoResponse422) & {
  headers: Headers;
};

export type addPortalRequestPhotoResponse = (addPortalRequestPhotoResponseSuccess | addPortalRequestPhotoResponseError)

export const getAddPortalRequestPhotoUrl = (requestId: number,) => {




  return `/api/portal/maintenance/${requestId}/photos`
}

/**
 * @summary Add Portal Request Photo
 */
export const addPortalRequestPhoto = async (requestId: number,
    bodyAddPortalRequestPhoto: BodyAddPortalRequestPhoto, options?: Parameters<typeof apiFetch>[1]): Promise<addPortalRequestPhotoResponse> => {
    const formData = new FormData();
formData.append(`file`, bodyAddPortalRequestPhoto.file);

  return apiFetch<addPortalRequestPhotoResponse>(getAddPortalRequestPhotoUrl(requestId),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}





export const getAddPortalRequestPhotoMutationKey = () => ['addPortalRequestPhoto'] as const;

export const getAddPortalRequestPhotoMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addPortalRequestPhoto>>, TError,AddPortalRequestPhotoMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof addPortalRequestPhoto>>, TError,AddPortalRequestPhotoMutationVariables, TContext> => {

const mutationKey = getAddPortalRequestPhotoMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addPortalRequestPhoto>>, AddPortalRequestPhotoMutationVariables> = (props) => {
          const {requestId,data} = props ?? {};

          return  addPortalRequestPhoto(requestId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddPortalRequestPhotoMutationResult = NonNullable<Awaited<ReturnType<typeof addPortalRequestPhoto>>>
    export type AddPortalRequestPhotoMutationBody = BodyAddPortalRequestPhoto
    export type AddPortalRequestPhotoMutationError = HTTPValidationError
    export type AddPortalRequestPhotoMutationVariables = {requestId: number;data: BodyAddPortalRequestPhoto}

    /**
 * @summary Add Portal Request Photo
 */
export const useAddPortalRequestPhoto = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addPortalRequestPhoto>>, TError,AddPortalRequestPhotoMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addPortalRequestPhoto>>,
        TError,
        AddPortalRequestPhotoMutationVariables,
        TContext
      > => {
      return useMutation(getAddPortalRequestPhotoMutationOptions(options), queryClient);
    }
    export type listPortalInspectionsResponse200 = {
  data: PortalInspectionsOut
  status: 200
}

export type listPortalInspectionsResponseSuccess = (listPortalInspectionsResponse200) & {
  headers: Headers;
};
;

export type listPortalInspectionsResponse = (listPortalInspectionsResponseSuccess)

export const getListPortalInspectionsUrl = () => {




  return `/api/portal/inspections`
}

/**
 * @summary List Portal Inspections
 */
export const listPortalInspections = async ( options?: Parameters<typeof apiFetch>[1]): Promise<listPortalInspectionsResponse> => {

  return apiFetch<listPortalInspectionsResponse>(getListPortalInspectionsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPortalInspectionsQueryKey = () => {
    return [
    `/api/portal/inspections`
    ] as const;
    }


export const getListPortalInspectionsQueryOptions = <TData = Awaited<ReturnType<typeof listPortalInspections>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPortalInspections>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPortalInspectionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPortalInspections>>> = ({ signal }) => listPortalInspections({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPortalInspections>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListPortalInspectionsQueryResult = NonNullable<Awaited<ReturnType<typeof listPortalInspections>>>
export type ListPortalInspectionsQueryError = unknown


export function useListPortalInspections<TData = Awaited<ReturnType<typeof listPortalInspections>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPortalInspections>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPortalInspections>>,
          TError,
          Awaited<ReturnType<typeof listPortalInspections>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPortalInspections<TData = Awaited<ReturnType<typeof listPortalInspections>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPortalInspections>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPortalInspections>>,
          TError,
          Awaited<ReturnType<typeof listPortalInspections>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPortalInspections<TData = Awaited<ReturnType<typeof listPortalInspections>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPortalInspections>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Portal Inspections
 */

export function useListPortalInspections<TData = Awaited<ReturnType<typeof listPortalInspections>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPortalInspections>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPortalInspectionsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type acknowledgePortalInspectionResponse200 = {
  data: PortalInspectionsOut
  status: 200
}

export type acknowledgePortalInspectionResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type acknowledgePortalInspectionResponseSuccess = (acknowledgePortalInspectionResponse200) & {
  headers: Headers;
};
export type acknowledgePortalInspectionResponseError = (acknowledgePortalInspectionResponse422) & {
  headers: Headers;
};

export type acknowledgePortalInspectionResponse = (acknowledgePortalInspectionResponseSuccess | acknowledgePortalInspectionResponseError)

export const getAcknowledgePortalInspectionUrl = (inspectionId: number,) => {




  return `/api/portal/inspections/${inspectionId}/acknowledge`
}

/**
 * @summary Acknowledge Portal Inspection
 */
export const acknowledgePortalInspection = async (inspectionId: number,
    inspectionAcknowledgeIn: InspectionAcknowledgeIn, options?: Parameters<typeof apiFetch>[1]): Promise<acknowledgePortalInspectionResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<acknowledgePortalInspectionResponse>(getAcknowledgePortalInspectionUrl(inspectionId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(inspectionAcknowledgeIn)
  }
);}





export const getAcknowledgePortalInspectionMutationKey = () => ['acknowledgePortalInspection'] as const;

export const getAcknowledgePortalInspectionMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acknowledgePortalInspection>>, TError,AcknowledgePortalInspectionMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof acknowledgePortalInspection>>, TError,AcknowledgePortalInspectionMutationVariables, TContext> => {

const mutationKey = getAcknowledgePortalInspectionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof acknowledgePortalInspection>>, AcknowledgePortalInspectionMutationVariables> = (props) => {
          const {inspectionId,data} = props ?? {};

          return  acknowledgePortalInspection(inspectionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AcknowledgePortalInspectionMutationResult = NonNullable<Awaited<ReturnType<typeof acknowledgePortalInspection>>>
    export type AcknowledgePortalInspectionMutationBody = InspectionAcknowledgeIn
    export type AcknowledgePortalInspectionMutationError = HTTPValidationError
    export type AcknowledgePortalInspectionMutationVariables = {inspectionId: number;data: InspectionAcknowledgeIn}

    /**
 * @summary Acknowledge Portal Inspection
 */
export const useAcknowledgePortalInspection = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acknowledgePortalInspection>>, TError,AcknowledgePortalInspectionMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof acknowledgePortalInspection>>,
        TError,
        AcknowledgePortalInspectionMutationVariables,
        TContext
      > => {
      return useMutation(getAcknowledgePortalInspectionMutationOptions(options), queryClient);
    }
    export type getPortalInspectionPdfResponse200 = {
  data: Blob
  status: 200
}

export type getPortalInspectionPdfResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type getPortalInspectionPdfResponseSuccess = (getPortalInspectionPdfResponse200) & {
  headers: Headers;
};
export type getPortalInspectionPdfResponseError = (getPortalInspectionPdfResponse422) & {
  headers: Headers;
};

export type getPortalInspectionPdfResponse = (getPortalInspectionPdfResponseSuccess | getPortalInspectionPdfResponseError)

export const getGetPortalInspectionPdfUrl = (inspectionId: number,) => {




  return `/api/portal/inspections/${inspectionId}/pdf`
}

/**
 * @summary Get Portal Inspection Pdf
 */
export const getPortalInspectionPdf = async (inspectionId: number, options?: Parameters<typeof apiFetch>[1]): Promise<getPortalInspectionPdfResponse> => {

  return apiFetch<getPortalInspectionPdfResponse>(getGetPortalInspectionPdfUrl(inspectionId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPortalInspectionPdfQueryKey = (inspectionId: number,) => {
    return [
    `/api/portal/inspections/${inspectionId}/pdf`
    ] as const;
    }


export const getGetPortalInspectionPdfQueryOptions = <TData = Awaited<ReturnType<typeof getPortalInspectionPdf>>, TError = HTTPValidationError>(inspectionId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPortalInspectionPdf>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPortalInspectionPdfQueryKey(inspectionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPortalInspectionPdf>>> = ({ signal }) => getPortalInspectionPdf(inspectionId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: inspectionId !== null && inspectionId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPortalInspectionPdf>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPortalInspectionPdfQueryResult = NonNullable<Awaited<ReturnType<typeof getPortalInspectionPdf>>>
export type GetPortalInspectionPdfQueryError = HTTPValidationError


export function useGetPortalInspectionPdf<TData = Awaited<ReturnType<typeof getPortalInspectionPdf>>, TError = HTTPValidationError>(
 inspectionId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPortalInspectionPdf>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPortalInspectionPdf>>,
          TError,
          Awaited<ReturnType<typeof getPortalInspectionPdf>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPortalInspectionPdf<TData = Awaited<ReturnType<typeof getPortalInspectionPdf>>, TError = HTTPValidationError>(
 inspectionId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPortalInspectionPdf>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPortalInspectionPdf>>,
          TError,
          Awaited<ReturnType<typeof getPortalInspectionPdf>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPortalInspectionPdf<TData = Awaited<ReturnType<typeof getPortalInspectionPdf>>, TError = HTTPValidationError>(
 inspectionId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPortalInspectionPdf>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Portal Inspection Pdf
 */

export function useGetPortalInspectionPdf<TData = Awaited<ReturnType<typeof getPortalInspectionPdf>>, TError = HTTPValidationError>(
 inspectionId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPortalInspectionPdf>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPortalInspectionPdfQueryOptions(inspectionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type listPortalNoticesResponse200 = {
  data: PortalNoticesOut
  status: 200
}

export type listPortalNoticesResponseSuccess = (listPortalNoticesResponse200) & {
  headers: Headers;
};
;

export type listPortalNoticesResponse = (listPortalNoticesResponseSuccess)

export const getListPortalNoticesUrl = () => {




  return `/api/portal/notices`
}

/**
 * @summary List Portal Notices
 */
export const listPortalNotices = async ( options?: Parameters<typeof apiFetch>[1]): Promise<listPortalNoticesResponse> => {

  return apiFetch<listPortalNoticesResponse>(getListPortalNoticesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPortalNoticesQueryKey = () => {
    return [
    `/api/portal/notices`
    ] as const;
    }


export const getListPortalNoticesQueryOptions = <TData = Awaited<ReturnType<typeof listPortalNotices>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPortalNotices>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPortalNoticesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPortalNotices>>> = ({ signal }) => listPortalNotices({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPortalNotices>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListPortalNoticesQueryResult = NonNullable<Awaited<ReturnType<typeof listPortalNotices>>>
export type ListPortalNoticesQueryError = unknown


export function useListPortalNotices<TData = Awaited<ReturnType<typeof listPortalNotices>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPortalNotices>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPortalNotices>>,
          TError,
          Awaited<ReturnType<typeof listPortalNotices>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPortalNotices<TData = Awaited<ReturnType<typeof listPortalNotices>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPortalNotices>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPortalNotices>>,
          TError,
          Awaited<ReturnType<typeof listPortalNotices>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPortalNotices<TData = Awaited<ReturnType<typeof listPortalNotices>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPortalNotices>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Portal Notices
 */

export function useListPortalNotices<TData = Awaited<ReturnType<typeof listPortalNotices>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPortalNotices>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPortalNoticesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type getPortalNoticePdfResponse200 = {
  data: Blob
  status: 200
}

export type getPortalNoticePdfResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type getPortalNoticePdfResponseSuccess = (getPortalNoticePdfResponse200) & {
  headers: Headers;
};
export type getPortalNoticePdfResponseError = (getPortalNoticePdfResponse422) & {
  headers: Headers;
};

export type getPortalNoticePdfResponse = (getPortalNoticePdfResponseSuccess | getPortalNoticePdfResponseError)

export const getGetPortalNoticePdfUrl = (noticeId: number,) => {




  return `/api/portal/notices/${noticeId}/pdf`
}

/**
 * @summary Get Portal Notice Pdf
 */
export const getPortalNoticePdf = async (noticeId: number, options?: Parameters<typeof apiFetch>[1]): Promise<getPortalNoticePdfResponse> => {

  return apiFetch<getPortalNoticePdfResponse>(getGetPortalNoticePdfUrl(noticeId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPortalNoticePdfQueryKey = (noticeId: number,) => {
    return [
    `/api/portal/notices/${noticeId}/pdf`
    ] as const;
    }


export const getGetPortalNoticePdfQueryOptions = <TData = Awaited<ReturnType<typeof getPortalNoticePdf>>, TError = HTTPValidationError>(noticeId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPortalNoticePdf>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPortalNoticePdfQueryKey(noticeId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPortalNoticePdf>>> = ({ signal }) => getPortalNoticePdf(noticeId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: noticeId !== null && noticeId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPortalNoticePdf>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPortalNoticePdfQueryResult = NonNullable<Awaited<ReturnType<typeof getPortalNoticePdf>>>
export type GetPortalNoticePdfQueryError = HTTPValidationError


export function useGetPortalNoticePdf<TData = Awaited<ReturnType<typeof getPortalNoticePdf>>, TError = HTTPValidationError>(
 noticeId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPortalNoticePdf>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPortalNoticePdf>>,
          TError,
          Awaited<ReturnType<typeof getPortalNoticePdf>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPortalNoticePdf<TData = Awaited<ReturnType<typeof getPortalNoticePdf>>, TError = HTTPValidationError>(
 noticeId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPortalNoticePdf>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPortalNoticePdf>>,
          TError,
          Awaited<ReturnType<typeof getPortalNoticePdf>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPortalNoticePdf<TData = Awaited<ReturnType<typeof getPortalNoticePdf>>, TError = HTTPValidationError>(
 noticeId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPortalNoticePdf>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Portal Notice Pdf
 */

export function useGetPortalNoticePdf<TData = Awaited<ReturnType<typeof getPortalNoticePdf>>, TError = HTTPValidationError>(
 noticeId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPortalNoticePdf>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPortalNoticePdfQueryOptions(noticeId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type listPortalRenewalsResponse200 = {
  data: PortalRenewalsOut
  status: 200
}

export type listPortalRenewalsResponseSuccess = (listPortalRenewalsResponse200) & {
  headers: Headers;
};
;

export type listPortalRenewalsResponse = (listPortalRenewalsResponseSuccess)

export const getListPortalRenewalsUrl = () => {




  return `/api/portal/renewals`
}

/**
 * @summary List Portal Renewals
 */
export const listPortalRenewals = async ( options?: Parameters<typeof apiFetch>[1]): Promise<listPortalRenewalsResponse> => {

  return apiFetch<listPortalRenewalsResponse>(getListPortalRenewalsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPortalRenewalsQueryKey = () => {
    return [
    `/api/portal/renewals`
    ] as const;
    }


export const getListPortalRenewalsQueryOptions = <TData = Awaited<ReturnType<typeof listPortalRenewals>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPortalRenewals>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPortalRenewalsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPortalRenewals>>> = ({ signal }) => listPortalRenewals({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPortalRenewals>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListPortalRenewalsQueryResult = NonNullable<Awaited<ReturnType<typeof listPortalRenewals>>>
export type ListPortalRenewalsQueryError = unknown


export function useListPortalRenewals<TData = Awaited<ReturnType<typeof listPortalRenewals>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPortalRenewals>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPortalRenewals>>,
          TError,
          Awaited<ReturnType<typeof listPortalRenewals>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPortalRenewals<TData = Awaited<ReturnType<typeof listPortalRenewals>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPortalRenewals>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPortalRenewals>>,
          TError,
          Awaited<ReturnType<typeof listPortalRenewals>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPortalRenewals<TData = Awaited<ReturnType<typeof listPortalRenewals>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPortalRenewals>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Portal Renewals
 */

export function useListPortalRenewals<TData = Awaited<ReturnType<typeof listPortalRenewals>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPortalRenewals>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPortalRenewalsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type respondToPortalRenewalResponse200 = {
  data: PortalRenewalsOut
  status: 200
}

export type respondToPortalRenewalResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type respondToPortalRenewalResponseSuccess = (respondToPortalRenewalResponse200) & {
  headers: Headers;
};
export type respondToPortalRenewalResponseError = (respondToPortalRenewalResponse422) & {
  headers: Headers;
};

export type respondToPortalRenewalResponse = (respondToPortalRenewalResponseSuccess | respondToPortalRenewalResponseError)

export const getRespondToPortalRenewalUrl = (offerId: number,) => {




  return `/api/portal/renewals/${offerId}/respond`
}

/**
 * @summary Respond To Portal Renewal
 */
export const respondToPortalRenewal = async (offerId: number,
    renewalResponseIn: RenewalResponseIn, options?: Parameters<typeof apiFetch>[1]): Promise<respondToPortalRenewalResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<respondToPortalRenewalResponse>(getRespondToPortalRenewalUrl(offerId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(renewalResponseIn)
  }
);}





export const getRespondToPortalRenewalMutationKey = () => ['respondToPortalRenewal'] as const;

export const getRespondToPortalRenewalMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof respondToPortalRenewal>>, TError,RespondToPortalRenewalMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof respondToPortalRenewal>>, TError,RespondToPortalRenewalMutationVariables, TContext> => {

const mutationKey = getRespondToPortalRenewalMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof respondToPortalRenewal>>, RespondToPortalRenewalMutationVariables> = (props) => {
          const {offerId,data} = props ?? {};

          return  respondToPortalRenewal(offerId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RespondToPortalRenewalMutationResult = NonNullable<Awaited<ReturnType<typeof respondToPortalRenewal>>>
    export type RespondToPortalRenewalMutationBody = RenewalResponseIn
    export type RespondToPortalRenewalMutationError = HTTPValidationError
    export type RespondToPortalRenewalMutationVariables = {offerId: number;data: RenewalResponseIn}

    /**
 * @summary Respond To Portal Renewal
 */
export const useRespondToPortalRenewal = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof respondToPortalRenewal>>, TError,RespondToPortalRenewalMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof respondToPortalRenewal>>,
        TError,
        RespondToPortalRenewalMutationVariables,
        TContext
      > => {
      return useMutation(getRespondToPortalRenewalMutationOptions(options), queryClient);
    }
    export type listPortalDepositLettersResponse200 = {
  data: PortalDepositLettersOut
  status: 200
}

export type listPortalDepositLettersResponseSuccess = (listPortalDepositLettersResponse200) & {
  headers: Headers;
};
;

export type listPortalDepositLettersResponse = (listPortalDepositLettersResponseSuccess)

export const getListPortalDepositLettersUrl = () => {




  return `/api/portal/deposit-letters`
}

/**
 * @summary List Portal Deposit Letters
 */
export const listPortalDepositLetters = async ( options?: Parameters<typeof apiFetch>[1]): Promise<listPortalDepositLettersResponse> => {

  return apiFetch<listPortalDepositLettersResponse>(getListPortalDepositLettersUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPortalDepositLettersQueryKey = () => {
    return [
    `/api/portal/deposit-letters`
    ] as const;
    }


export const getListPortalDepositLettersQueryOptions = <TData = Awaited<ReturnType<typeof listPortalDepositLetters>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPortalDepositLetters>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPortalDepositLettersQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPortalDepositLetters>>> = ({ signal }) => listPortalDepositLetters({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPortalDepositLetters>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListPortalDepositLettersQueryResult = NonNullable<Awaited<ReturnType<typeof listPortalDepositLetters>>>
export type ListPortalDepositLettersQueryError = unknown


export function useListPortalDepositLetters<TData = Awaited<ReturnType<typeof listPortalDepositLetters>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPortalDepositLetters>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPortalDepositLetters>>,
          TError,
          Awaited<ReturnType<typeof listPortalDepositLetters>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPortalDepositLetters<TData = Awaited<ReturnType<typeof listPortalDepositLetters>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPortalDepositLetters>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPortalDepositLetters>>,
          TError,
          Awaited<ReturnType<typeof listPortalDepositLetters>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPortalDepositLetters<TData = Awaited<ReturnType<typeof listPortalDepositLetters>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPortalDepositLetters>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Portal Deposit Letters
 */

export function useListPortalDepositLetters<TData = Awaited<ReturnType<typeof listPortalDepositLetters>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPortalDepositLetters>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPortalDepositLettersQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type getPortalDepositLetterResponse200 = {
  data: Blob
  status: 200
}

export type getPortalDepositLetterResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type getPortalDepositLetterResponseSuccess = (getPortalDepositLetterResponse200) & {
  headers: Headers;
};
export type getPortalDepositLetterResponseError = (getPortalDepositLetterResponse422) & {
  headers: Headers;
};

export type getPortalDepositLetterResponse = (getPortalDepositLetterResponseSuccess | getPortalDepositLetterResponseError)

export const getGetPortalDepositLetterUrl = (letterId: number,) => {




  return `/api/portal/deposit-letters/${letterId}/pdf`
}

/**
 * @summary Get Portal Deposit Letter
 */
export const getPortalDepositLetter = async (letterId: number, options?: Parameters<typeof apiFetch>[1]): Promise<getPortalDepositLetterResponse> => {

  return apiFetch<getPortalDepositLetterResponse>(getGetPortalDepositLetterUrl(letterId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPortalDepositLetterQueryKey = (letterId: number,) => {
    return [
    `/api/portal/deposit-letters/${letterId}/pdf`
    ] as const;
    }


export const getGetPortalDepositLetterQueryOptions = <TData = Awaited<ReturnType<typeof getPortalDepositLetter>>, TError = HTTPValidationError>(letterId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPortalDepositLetter>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPortalDepositLetterQueryKey(letterId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPortalDepositLetter>>> = ({ signal }) => getPortalDepositLetter(letterId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: letterId !== null && letterId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPortalDepositLetter>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPortalDepositLetterQueryResult = NonNullable<Awaited<ReturnType<typeof getPortalDepositLetter>>>
export type GetPortalDepositLetterQueryError = HTTPValidationError


export function useGetPortalDepositLetter<TData = Awaited<ReturnType<typeof getPortalDepositLetter>>, TError = HTTPValidationError>(
 letterId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPortalDepositLetter>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPortalDepositLetter>>,
          TError,
          Awaited<ReturnType<typeof getPortalDepositLetter>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPortalDepositLetter<TData = Awaited<ReturnType<typeof getPortalDepositLetter>>, TError = HTTPValidationError>(
 letterId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPortalDepositLetter>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPortalDepositLetter>>,
          TError,
          Awaited<ReturnType<typeof getPortalDepositLetter>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPortalDepositLetter<TData = Awaited<ReturnType<typeof getPortalDepositLetter>>, TError = HTTPValidationError>(
 letterId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPortalDepositLetter>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Portal Deposit Letter
 */

export function useGetPortalDepositLetter<TData = Awaited<ReturnType<typeof getPortalDepositLetter>>, TError = HTTPValidationError>(
 letterId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPortalDepositLetter>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPortalDepositLetterQueryOptions(letterId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type listPortalDocumentsResponse200 = {
  data: PortalDocumentsOut
  status: 200
}

export type listPortalDocumentsResponseSuccess = (listPortalDocumentsResponse200) & {
  headers: Headers;
};
;

export type listPortalDocumentsResponse = (listPortalDocumentsResponseSuccess)

export const getListPortalDocumentsUrl = () => {




  return `/api/portal/documents`
}

/**
 * @summary List Portal Documents
 */
export const listPortalDocuments = async ( options?: Parameters<typeof apiFetch>[1]): Promise<listPortalDocumentsResponse> => {

  return apiFetch<listPortalDocumentsResponse>(getListPortalDocumentsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPortalDocumentsQueryKey = () => {
    return [
    `/api/portal/documents`
    ] as const;
    }


export const getListPortalDocumentsQueryOptions = <TData = Awaited<ReturnType<typeof listPortalDocuments>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPortalDocuments>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPortalDocumentsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPortalDocuments>>> = ({ signal }) => listPortalDocuments({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPortalDocuments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListPortalDocumentsQueryResult = NonNullable<Awaited<ReturnType<typeof listPortalDocuments>>>
export type ListPortalDocumentsQueryError = unknown


export function useListPortalDocuments<TData = Awaited<ReturnType<typeof listPortalDocuments>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPortalDocuments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPortalDocuments>>,
          TError,
          Awaited<ReturnType<typeof listPortalDocuments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPortalDocuments<TData = Awaited<ReturnType<typeof listPortalDocuments>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPortalDocuments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPortalDocuments>>,
          TError,
          Awaited<ReturnType<typeof listPortalDocuments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPortalDocuments<TData = Awaited<ReturnType<typeof listPortalDocuments>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPortalDocuments>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Portal Documents
 */

export function useListPortalDocuments<TData = Awaited<ReturnType<typeof listPortalDocuments>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPortalDocuments>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPortalDocumentsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type getPortalDocumentUrlResponse200 = {
  data: DownloadUrlOut
  status: 200
}

export type getPortalDocumentUrlResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type getPortalDocumentUrlResponseSuccess = (getPortalDocumentUrlResponse200) & {
  headers: Headers;
};
export type getPortalDocumentUrlResponseError = (getPortalDocumentUrlResponse422) & {
  headers: Headers;
};

export type getPortalDocumentUrlResponse = (getPortalDocumentUrlResponseSuccess | getPortalDocumentUrlResponseError)

export const getGetPortalDocumentUrlUrl = (documentId: number,) => {




  return `/api/portal/documents/${documentId}/download-url`
}

/**
 * @summary Get Portal Document Url
 */
export const getPortalDocumentUrl = async (documentId: number, options?: Parameters<typeof apiFetch>[1]): Promise<getPortalDocumentUrlResponse> => {

  return apiFetch<getPortalDocumentUrlResponse>(getGetPortalDocumentUrlUrl(documentId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPortalDocumentUrlQueryKey = (documentId: number,) => {
    return [
    `/api/portal/documents/${documentId}/download-url`
    ] as const;
    }


export const getGetPortalDocumentUrlQueryOptions = <TData = Awaited<ReturnType<typeof getPortalDocumentUrl>>, TError = HTTPValidationError>(documentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPortalDocumentUrl>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPortalDocumentUrlQueryKey(documentId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPortalDocumentUrl>>> = ({ signal }) => getPortalDocumentUrl(documentId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: documentId !== null && documentId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPortalDocumentUrl>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPortalDocumentUrlQueryResult = NonNullable<Awaited<ReturnType<typeof getPortalDocumentUrl>>>
export type GetPortalDocumentUrlQueryError = HTTPValidationError


export function useGetPortalDocumentUrl<TData = Awaited<ReturnType<typeof getPortalDocumentUrl>>, TError = HTTPValidationError>(
 documentId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPortalDocumentUrl>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPortalDocumentUrl>>,
          TError,
          Awaited<ReturnType<typeof getPortalDocumentUrl>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPortalDocumentUrl<TData = Awaited<ReturnType<typeof getPortalDocumentUrl>>, TError = HTTPValidationError>(
 documentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPortalDocumentUrl>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPortalDocumentUrl>>,
          TError,
          Awaited<ReturnType<typeof getPortalDocumentUrl>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPortalDocumentUrl<TData = Awaited<ReturnType<typeof getPortalDocumentUrl>>, TError = HTTPValidationError>(
 documentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPortalDocumentUrl>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Portal Document Url
 */

export function useGetPortalDocumentUrl<TData = Awaited<ReturnType<typeof getPortalDocumentUrl>>, TError = HTTPValidationError>(
 documentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPortalDocumentUrl>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPortalDocumentUrlQueryOptions(documentId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






